export default {
    methods: {
        validateForm(form_id) {
            const form = $('#' + form_id).parsley({
                excluded:
                    'input[type=button], input[type=submit], input[type=reset], :hidden',
            });

            form.reset();
            return form.validate();
        },

        getOutlets(callback = () => {}) {
            let api = Laroute.route('franchise.vue.outlets');
            axios.get(api).then(res => callback(res.data.data));
        },

        getProducts(callback = () => {}, options = {}) {
            let api = Laroute.route('franchise.vue.products');

            axios.get(api, options).then(res => {
                callback(res.data.data);
            });
        },

        toTitleCase(text) {
            return text
                .replace(/_/g, ' ')
                .replace(/(^[a-z])|(\s+[a-z])/g, txt => txt.toUpperCase());
        },

        searchProducts(callback = () => {}) {
            return _.debounce(query => {
                let options = {
                    params: {
                        query: query,
                        limit: 25,
                    },
                };

                this.getProducts(this.getProducts(callback, options));
            }, 500);
        },

        showToastrError(msg) {
            toastr.error(msg);
        },

        showToastrSuccess(msg = 'Operation has successfully completed') {
            toastr.success(msg);
        },

        showApiError(res, default_msg = null) {
            let msg = '';
            let response = res.response;

            if (!_.isUndefined(response)) {
                if (response.status === 422) {
                    let data = response.data.errors;
                    msg += '<ul class="list-unstyled">';

                    for (let key in data) {
                        msg += '<li>';
                        msg += data[key];
                        msg += '</li>';
                    }

                    msg += '</ul>';
                } else {
                    msg = response.statusText;

                    if (response.data != null) {
                        let err_msg = response.data.message;

                        if (err_msg != null) {
                            msg = `${msg}: ${err_msg}`;
                        }
                    }
                }
            } else if (!_.isUndefined(res)) {
                msg = res.statusText;

                if (res.data != null) {
                    let err_msg = res.data.message;

                    if (err_msg != null) {
                        msg = `${msg}: ${err_msg}`;
                    }
                }
            } else {
                if (!_.isNull(default_msg)) {
                    msg = default_msg;
                } else {
                    msg = res;
                }
            }

            toastr.error(msg);
        },

        refreshVuetable(ref = 'datatable') {
            this.$refs[ref].getData();
        },

        scrollToTop(element) {
            $(element).animate({ scrollTop: 0 }, 'slow');
        },

        stripTags(input, allowed) {
            allowed = (
                ((allowed || '') + '')
                    .toLowerCase()
                    .match(/<[a-z][a-z0-9]*>/g) || []
            ).join('');
            var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
            var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
            return input
                .replace(commentsAndPhpTags, '')
                .replace(tags, function($0, $1) {
                    return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1
                        ? $0
                        : '';
                });
        },

        /**
         * Whether a value contains HTML-tag-shaped input.
         *
         * Client-side mirror of App\Rules\NoHtmlTagsRule — keep the two in step.
         * The server is the authority; this exists so a form can show inline
         * feedback instead of a 422, and so a search box never fires a request
         * that is going to be rejected.
         *
         * Matches the tag-opening shape (`<` immediately followed by a letter,
         * `/`, `!` or `?`) rather than banning special characters, so
         * "Q&A: RON95 & B7", "it's", "A/B" and "under < 5 min" stay valid while
         * `<script>`, `</div>`, `<img onerror=…>` and `<!--` do not.
         *
         * Do NOT use this on rich text (e.g. a Quill body) — tags are
         * legitimate there and App\Support\HtmlSanitizer is the right control.
         */
        hasHtmlTags(value) {
            return /<\/?[a-z!?]/i.test(value || '');
        },

        /** Validation message for a plain-text field, or '' when valid. */
        htmlTagsError(value) {
            return this.hasHtmlTags(value)
                ? 'HTML tags are not allowed in this field.'
                : '';
        },

        /** Validation message for a search box, or '' when valid. */
        htmlTagsSearchError(value) {
            return this.hasHtmlTags(value)
                ? 'HTML tags are not allowed in the search field.'
                : '';
        },

        pluralize(singular, plural, number) {
            if (!number) {
                return '';
            }

            return number + ' ' + (number > 1 ? plural : singular);
        },

        swalAlertConfirmationAjax(
            url,
            {
                method = 'post',
                title = 'Are you sure ?',
                text = '',
                type = 'warning',
                successMsg = 'Operation has successfully completed',
                successCallback = () => {},
                input = null,
                inputOptions = {},
                inputValue = '',
                inputParam = 'value',
                paramOptions = {},
                confirmButtonColor = '#3085d6',
                cancelButtonColor = '#fff',
                cancelButtonClass = 'text-dark',
                confirmButtonText = 'Submit',
            } = {},
        ) {
            let swalOptions = {
                title,
                text,
                type,
                confirmButtonColor,
                showCancelButton: true,
                cancelButtonClass,
                cancelButtonColor,
                confirmButtonText,
                showLoaderOnConfirm: true,
                preConfirm: res => {
                    let options = paramOptions;

                    if (input !== null) {
                        options = _.merge(paramOptions, { [inputParam]: res });
                    }

                    return axios[method](url, options);
                },

                allowOutsideClick: () => !swal.isLoading(),
            };

            if (input !== null) {
                swalOptions.input = input;
                swalOptions.inputOptions = inputOptions;
                swalOptions.inputValue = inputValue;
            }

            return swal(swalOptions)
                .then(res => {
                    if (res.value) {
                        successCallback();
                        swal({
                            type: 'success',
                            html: successMsg,
                        });
                    }
                })
                .catch(err => {
                    let errorMessage = err;

                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    ) {
                        errorMessage = err.response.data.message;
                    }

                    swal({
                        type: 'error',
                        text: errorMessage,
                    });
                });
        },

        route(name, parameters, route) {
            return Laroute.route(name, parameters, route);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/index.js